import React from "react"

export const InfoEmail: React.FC = () => {
  return <a href="mailto:info@gogreenup.nl">info@gogreenup.nl</a>
}